import React from "react";
import { DatePicker } from "@mantine/dates";
import { IconTrash, IconPencil } from "@tabler/icons";
import _ from "lodash";

import { ENUM_FORM_DISPLAY, ENUM_FORM_LAYOUT_CONTAINER } from "./pageList";
import LocalPageList from "./localPageList";
import ActionCellRender from "./actionCellRender";

import { TextInput, Select } from "@mantine/core";
import { DATA_COUNTRY, DATA_GENDERS, DATA_NATIONALITY } from "../data/options";
import { useCellRender } from "../hooks/useCellRender";

const ContactList = ({
	form: mainForm,
	name,
	phoneField = "phone",
	...props
}) => {
	const contacts = _.get(mainForm.values, name) ?? [];

	const [cellRender] = useCellRender();

	const tableSchema = {
		hidePagination: true,
		columns: [
			{ field: "name", headerName: "English Name" },
			{ field: "cname", headerName: "Chinese Name" },
			{ field: "gender", headerName: "Gender" },
			{
				field: "birthday",
				headerName: "Birthday",
				cellRender: (col, data) =>
					data.birthday ? cellRender.Date(data.birthday, "YYYY-MM-DD") : "",
			},
			{ field: "nationality", headerName: "Nationality" },
			{ field: "residentialCountry", headerName: "Resident Country" },
			{ field: "title", headerName: "Relationship / Title" },
			{ field: phoneField, headerName: "Phone" },
			{ field: "email", headerName: "Email" },

			{
				cellRender: ActionCellRender,
				isAction: true,
				actions: [
					{
						name: "edit",
						label: "Edit",
						icon: IconPencil,
					},
					{
						name: "delete",
						label: "Delete",
						icon: IconTrash,
						props: {},
					},
				],
				actionMenu: [],
			},
		],
		searchableFields: ["name", "cname", "email", "nationality", "residentialCountry"],
	};

	const formSchema = {
		title: "Related Person Info",
		display: {
			mode: ENUM_FORM_DISPLAY.MODAL,
			size: "xl",
		},
		initialValues: {},

		layout: {
			containers: [
				{
					key: "section-contact",
					parent: null,
					type: ENUM_FORM_LAYOUT_CONTAINER.SECTION,
					props: {
						title: "Related Person Info",
						titleOrder: 3,
						description: "Please fill in the related person info",
						withBorder: false,
						ml: 10,
						mt: 0,
						mb: 10,
					},
				},
				{
					key: "g",
					parent: "section-contact",
					type: ENUM_FORM_LAYOUT_CONTAINER.GRID,
					cols: [
						{
							key: "g1",
							props: {
								span: 6,
							},
						},
						{
							key: "g2",
							props: {
								span: 6,
							},
						},
					],
				},
			],

			fields: [
				{
					name: "name",
					component: TextInput,
					parent: "g1",
					props: {
						required: true,
						label: "English Name",
					},
				},
				{
					name: "cname",
					component: TextInput,
					parent: "g2",
					props: {
						label: "Chinese Name",
					},
				},
				{
					name: "gender",
					component: Select,
					parent: "g1",
					props: {
						label: "Gender",
						data: DATA_GENDERS,
						searchable: true,
						clearable: true,
						withinPortal: true,
						zIndex: 1000,
					},
				},
				{
					name: "birthday",
					component: DatePicker,
					parent: "g2",
					type: "datePicker",
					props: {
						label: "Birthday",
						zIndex: 1000,
						placeholder: "Pick Date",
						allowFreeInput: true,
					},
				},
				{
					name: "nationality",
					component: Select,
					parent: "g1",
					props: {
						label: "Nationality",
						data: DATA_NATIONALITY,
						searchable: true,
						clearable: true,
						withinPortal: true,
						zIndex: 1000,
					},
				},
				{
					name: "residentialCountry",
					component: Select,
					parent: "g2",
					props: {
						label: "Resident Country",
						data: DATA_COUNTRY,
						searchable: true,
						clearable: true,
						withinPortal: true,
						zIndex: 1000,
					},
				},
				{
					name: "title",
					component: TextInput,
					parent: "g1",
					props: {
						label: "Relationship / Title",
					},
				},
				{
					name: "department",
					component: TextInput,
					parent: "g2",
					props: {
						label: "Department",
					},
				},
				{
					name: phoneField,
					component: TextInput,
					parent: "g1",
					props: {
						label: "Phone",
					},
				},
				{
					name: "email",
					component: TextInput,
					parent: "g2",
					props: {
						label: "Email",
					},
				},
			],
		},
	};

	const onFormSubmit = (values) => {
		mainForm.setFieldValue(name, values);
	};

	return (
		<LocalPageList
			rows={contacts}
			onFormSubmit={onFormSubmit}
			tableSchema={tableSchema}
			formSchema={formSchema}
			{...props}
		/>
	);
};

export default ContactList;
